
const form = document.querySelector('form');
const fName = document.getElementById('Fname');
const lName = document.getElementById('Lname');
const emailReq = document.querySelector('input[type="email"]');
const passwordReq = document.getElementById('password');
const cpasswordReq = document.getElementById('cpassword');

NodeList.prototype.forEach = function (callback) {
    Array.prototype.forEach.call(this, callback);
  };

function checkInputsVal (value){
    return value === '' ? false : true;
}  
function checkEmail (email){
    const eM = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return eM.test(email);
}   
function checkPassword (password){
    const pM = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#/$%/^&/*])(?=.{7,})");
    return pM.test(password);
} 

function userFnameVal(){
    let val = false;
    const userFname = fName.value.trim();
    
    if(!checkInputsVal(userFname)){
        formErrMsg(fName);
    }else{
       formVal(fName);
       val = true;
    }
    return val;
}

function userLnameVal(){
    let val = false;
    const userLname = lName.value.trim();

    if(!checkInputsVal(userLname)){
        formErrMsg(lName);
    }else{
        formVal(lName);
        val = true;
    }
    return val;
}  

function userEmailVal(){
    let val = false;
    const userEmail = emailReq.value.trim();

    if(!checkInputsVal(userEmail)){
        formErrMsg(emailReq);
    }else if(!checkEmail(userEmail)){
        formErrMsg(emailReq);
    }else{
       formVal(emailReq);
       val = true;
    }
    return val;
}  

function userpasswordVal(){
    let val = false;
    const userPassword = passwordReq.value.trim();

    if(userPassword == ''){
        formVal(passwordReq);
            if(!checkInputsVal(userPassword)){
                formErrMsg(passwordReq);
            }
    }else if(!checkPassword(userPassword)){
        formErrMsg(passwordReq);
    }else{
       formVal(passwordReq);
       val = true;
    }
    return val;
} 

function userCpasswordVal(){
    let val = false;
    const password = passwordReq.value.trim();
    const cPassword = cpasswordReq.value.trim();

    if(cPassword == ''){formVal(cpasswordReq);
    }else if(cPassword !== password){
        formErrMsg(cpasswordReq);
    }else{
       formVal(cpasswordReq);
       val = true;
    }
    return val;
}  
form.addEventListener('submit', (ev) =>{
       ev.preventDefault();
       let isFname = userFnameVal();
       let isLname = userLnameVal();
       let isEmail = userEmailVal();
       let isPassword = userpasswordVal();
       let isCpassword = userCpasswordVal();
       let isForm = isFname && isLname && isEmail && isPassword && isCpassword;
         
});

function formErrMsg(inputType){
    const fnameErrMsg = document.querySelector('.fname-err');
    const lnameErrMsg = document.querySelector('.lname-err');
    const emailErrMsg = document.querySelector('.email-err');
    const passwordErrMsg = document.querySelector('.password-err');
    const CpasswordErrMsg = document.querySelector('.cpassword-err');
    const divMarginBottom = document.querySelector('.field-a-password');

    const validateForm = inputType.getAttribute('name');
    switch(validateForm){
        case 'Fname':
            fnameErrMsg.classList.replace('valid', 'invalid');
            fName.setAttribute('required', '');
        break;  
        case 'Lname':
            lnameErrMsg.classList.replace('valid', 'invalid');
            lName.setAttribute('required', '');
        break;
        case 'Email':
            emailErrMsg.classList.replace('valid', 'invalid');
            emailReq.setAttribute('required', '');
        break;
        case 'password':
            passwordErrMsg.classList.replace('valid', 'invalid');
            passwordReq.setAttribute('required', '');
            divMarginBottom.style.marginBottom = '20px';
        break;
        case 'Cpassword':
            CpasswordErrMsg.classList.replace('valid', 'invalid');

    }
}
    
function formVal(inputType){
    const fnameVal = document.querySelector('.fname-err');
    const lnameVal = document.querySelector('.lname-err');
    const emailVal = document.querySelector('.email-err');
    const passwordVal = document.querySelector('.password-err');
    const cpasswordVal = document.querySelector('.cpassword-err');
    
   
    const validateForm = inputType.getAttribute('name');

    switch(validateForm){
       case 'Fname':
           fnameVal.classList.replace('invalid', 'valid');
           fName.removeAttribute('required');
           
        break;
        case 'Lname':
            lnameVal.classList.replace('invalid', 'valid');
            lName.removeAttribute('required');
        break;
        case 'Email':
            emailVal.classList.replace('invalid', 'valid');
            emailReq.removeAttribute('required');
        break;
        case 'password':
            passwordVal.classList.replace('invalid', 'valid');
            passwordReq.removeAttribute('required');
        break;
        case 'Cpassword':
            cpasswordVal.classList.replace('invalid', 'valid');
            cpasswordReq.removeAttribute('required');
        break;

    }
}

form.addEventListener('input', function(e){
    const val = e.target.id;
    switch(val){
        case 'Fname':
            (
                (fName.value == "") ? formVal(fName) : userFnameVal()
            );
        break;
        case 'Lname':
            (
                (lName.value == "") ? formVal(lName) : userLnameVal()
            );
        break;
        case 'Email':
            (
                (emailReq.value == "") ? formVal(emailReq) : userEmailVal()
            );
        break; 
        case 'password':
            (
                (passwordReq.value == "") ? formVal(passwordReq ) : userpasswordVal()
            );
        break;
        case 'cpassword':
            userCpasswordVal();
        break;


    }
});
    
